import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IMemberRowProps } from './IMemberRowProps';
import { ROLES } from './roles';

/**
 * Рядок учасника (прототип v4 G:L2745): ініціали в колі 34px (--accent-soft), ім'я 600 з «(ви)», ел. пошта 12px, роль (вибір 30px) і
 * «Вилучити» (28px, колір небезпеки). Без права керувати учасниками, для чужого власника чи єдиного власника елементи вимкнені з поясненням.
 * Виділений рядок (перехід з автора запису) — тло --accent-soft зі смужкою акценту 3px ліворуч; його прокручено у видиму частину.
 */
export function MemberRow({ member, you, reason, onRole, onRemove, focused = false }: IMemberRowProps) {
  const { t } = useTranslation();
  const row = useRef<HTMLDivElement>(null);
  useEffect(() => { if (focused) row.current?.scrollIntoView({ block: 'center' }); }, [focused]);
  const roles = ROLES.includes(member.role) ? ROLES : [...ROLES, member.role];
  return (
    <div ref={row} className={cx('mb-row', focused && 'is-focus')}>
      <span className="mb-avatar" aria-hidden="true">{member.user.initials}</span>
      <div className="mb-who">
        <span className="mb-name">{member.user.name}{you && <span className="mb-you"> {t('membersPage.you')}</span>}</span>
        <span className="mb-email">{member.email}</span>
      </div>
      <select className="mb-select" value={member.role} disabled={!!reason} title={reason ?? undefined} aria-label={t('membersPage.roleOf', { name: member.user.name })}
        onChange={(e) => onRole(e.target.value)}>
        {roles.map((r) => <option key={r} value={r}>{t(`membersPage.roleNames.${r}`, { defaultValue: r })}</option>)}
      </select>
      <button type="button" className="mb-remove" disabled={!!reason || you} title={reason ?? (you ? t('membersPage.notYourself') : undefined)} onClick={onRemove}>
        {t('membersPage.remove')}
      </button>
    </div>
  );
}
